module.exports = __webpack_public_path__ + "static/media/selected_marker_freshwater.b3f2682b.svg";